// extracted by mini-css-extract-plugin
module.exports = {"img":"index_img__mbJQ0","btn":"index_btn__3dYqo"};